import { useEffect } from "react";
import { useWorkspaces } from "../../controllers/useWorkspaces";

const ROLE_LABEL: Record<string, string> = { ADMIN: "관리자", MEMBER: "멤버" };
const STATUS_LABEL: Record<string, string> = {
  PENDING: "대기 중", ACCEPTED: "수락됨", DECLINED: "거절됨", REVOKED: "철회됨", EXPIRED: "만료됨",
};

// My pending workspace invitations — accept or decline, so an invited (not-yet-a-member) user can
// join a workspace. Hosted either by `WorkspacesView`'s nested screens or, in the project shell, by
// its own rail entry — hence the injectable back action (see WorkspaceDetailView for the same idea).
export function InvitationsView({ ws, onBack }: {
  ws: ReturnType<typeof useWorkspaces>;
  onBack?: () => void;
}) {
  useEffect(() => {
    void ws.reloadMyInvitations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="detail">
      <div className="detail-name">
        <h1>내 초대</h1>
        <button className="btn ghost" style={{ width: "auto" }} onClick={onBack ?? ws.backToList}>
          {onBack ? "← 홈" : "← 워크스페이스"}
        </button>
      </div>
      <p className="meta">받은 워크스페이스 초대를 확인하고 수락하거나 거절할 수 있습니다.</p>

      {ws.error && <div className="note" style={{ background: "#fdeef0", marginBottom: 16 }}><b style={{ color: "var(--amber)" }}>오류:</b> {ws.error}</div>}

      {ws.loadingMyInvitations ? (
        <div className="center">불러오는 중…</div>
      ) : ws.myInvitations.length === 0 ? (
        <div className="sdui-list-empty">받은 초대가 없습니다.</div>
      ) : (
        <table className="sdui-table">
          <thead><tr><th>이메일</th><th>역할</th><th>상태</th><th>만료일</th><th data-align="end">작업</th></tr></thead>
          <tbody>
            {ws.myInvitations.map((inv) => (
              <tr key={inv.id}>
                <td>{inv.email}</td>
                <td>{ROLE_LABEL[inv.role] ?? inv.role}</td>
                <td>{STATUS_LABEL[inv.status] ?? inv.status}</td>
                <td>{new Date(inv.expiresAt).toLocaleDateString()}</td>
                <td data-align="end">
                  {inv.status === "PENDING" ? (
                    <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                      <button className="sdui-button sdui-button-secondary" onClick={() => void ws.declineMyInvitation(inv.id)}>거절</button>
                      <button className="sdui-button sdui-button-primary" onClick={() => void ws.acceptMyInvitation(inv.id)}>수락</button>
                    </div>
                  ) : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
